module.exports = __webpack_public_path__ + "static/media/snake.80610a6b.png";